<template>
  <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="search-area-div">更换包编号</div>
          <el-input
            size="mini"
            v-model="page.taskNo"
            class="ipt-sty"
            placeholder="请输入更换包编号"
          ></el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">新公司名称</div>
          <el-select
            v-model="page.newServiceTenantName"
            placeholder="请选择新公司名称"
            class="ipt-sty"
            filterable
            clearable
            size="mini"
          >
            <el-option
              v-for="item in serviceProviderList"
              :key="item.guid"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="6" class="search-btn-box">
          <el-button size="mini" type="info" @click="search">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">
            清空
          </el-button>
        </el-col>
      </el-row>
    </div>
    <div
      class="back-color-fff content-main-box"
      :style="'height:' + contentMainHeight + 'px;'"
    >
      <el-table
        :data="tableData"
        :height="tableHeight"
        stripe
        border
        style="width: 100%"
      >
        <el-table-column
          fixed="left"
          label="序号"
          width="60"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          fixed="left"
          prop="taskNo"
          width="180"
          label="更换包编号"
          show-overflow-tooltip
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.taskNo || "-" }}
          </template>
        </el-table-column>
        <el-table-column
          fixed="left"
          prop="taskTitle"
          min-width="260"
          label="更换包名"
          show-overflow-tooltip
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">
            <a
              class="txt-color"
              @click="goToTaskDeliverDetail(scope.row.taskGuid)"
            >
              {{ scope.row.taskTitle || "-" }}
            </a>
          </template>
        </el-table-column>
        <el-table-column
          prop="serviceTenantName"
          min-width="220"
          label="原公司名称"
          show-overflow-tooltip
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.serviceTenantName || "-" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="newServiceTenantName"
          min-width="220"
          label="新公司名称"
          show-overflow-tooltip
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.newServiceTenantName || "-" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="staffName"
          width="140"
          label="更换人"
          show-overflow-tooltip
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.staffName || "-" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          width="200"
          label="更换时间"
          show-overflow-tooltip
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.createTime | getTimeDate }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff content-pagination-box"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
  </div>
</template>

<script>
import { getServiceProviderList } from "@/api/msCustomerService";
import { getUpdateServicePage } from "@/api/msSalesPerformService";
import { ServiceProviderTypeEnum } from "../mixins/getTenantDetail";

const defaultPage = () => ({
  pageIndex: 1,
  pageSize: 50,
  totalPage: 0,
  totalRows: 0,
  taskNo: "",
  newServiceTenantName: "",
});

export default {
  data() {
    return {
      fullscreenLoading: false,
      tableHeight: window.innerHeight - 213,
      contentMainHeight: window.innerHeight - 197,
      page: defaultPage(),
      tableData: [],
      serviceProviderList: [],
    };
  },
  methods: {
    // 跳转任务包详情
    goToTaskDeliverDetail(guid) {
      this.$router.push({
        path: "/taskDeliverDetail",
        query: {
          guid: guid,
        },
      });
    },
    // 分页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getData();
    },
    // 分页
    handleCurrentChange(val) {
      this.page.pageIndex = val;
      this.getData();
    },
    // 获取更换记录列表
    async getData() {
      const userInfo = JSON.parse(localStorage.getItem("userInfo"));
      const params = {
        pageIndex: this.page.pageIndex,
        pageSize: this.page.pageSize,
        // staffGuid: userInfo.staffGuid,
        taskNo: this.page.taskNo,
        newServiceTenantName: this.page.newServiceTenantName,
      };
      this.fullscreenLoading = true;
      const { data } = await getUpdateServicePage(params);
      this.fullscreenLoading = false;
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.tableData = data.data.records || [];
      this.page.totalPage = data.data.totalPages;
      this.page.totalRows = data.data.totalRows;
    },
    // 获取 新公司名称 列表
    async getServiceProviderList() {
      const params = {
        serviceProviderTypeList: [
          ServiceProviderTypeEnum.THIRD_PARTY_SASS,
          ServiceProviderTypeEnum.GENERAL_CONTRACTOR,
        ],
      };
      this.fullscreenLoading = true;
      const { data } = await getServiceProviderList(params);
      this.fullscreenLoading = false;
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.serviceProviderList = data.data || [];
    },
    // 搜索
    search() {
      this.page.pageIndex = 1;
      this.getData();
    },
    // 清空搜索
    emptySearch() {
      this.page = defaultPage();
      this.getData();
    },
  },
  // 初始化
  async created() {
    await this.getServiceProviderList();
    this.getData();
  },
};
</script>

<style scoped lang="less"></style>
